export const ADMIN = 'admin'
export const TEACHER = 'teacher'
